import ContentLayout from '@/layouts/content-layout'
import ProgramsView from '@/sections/programs/view/programs-view'

export default function ProgramsPage() {
  return (
    <ContentLayout title="โปรแกรม">
      <ProgramsView />
    </ContentLayout>
  )
}
